import {
  base_colorContentBorder,
  base_colorSurfaceMuted,
  text_colorTextPrimary,
  text_colorTextSecondary,
  text_colorTextTertiary,
} from 'ext-ui/style/colors'
import { cornerRadius, spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_md,
} from 'ext-ui/style/typography'
import Markdown from 'markdown-to-jsx'
import styled from 'styled-components'

export const ChatWrapper = styled.div`
  width: 100%;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`

export const ChatBox = styled.div`
  min-height: 0;
  flex: 1;
  padding: 0;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: ${spacing(3)};
`

export const InputBox = styled.div`
  border-top: 1px solid ${base_colorContentBorder};
  padding: ${spacing(4)} 0;
  margin: 0 ${spacing(6)} ${spacing(6)};
`

export const MessageHistoryControl = styled.div`
  display: flex;
  justify-content: center;
`

export const ChatMarkdown = styled(Markdown)`
  ${font_md};
  font-family: ${font_family_weight_regular};
  color: ${text_colorTextPrimary};

  strong {
    font-family: ${font_family_weight_medium};
  }

  h1 {
    margin-bottom: ${spacing(4)};
  }

  h2 {
    margin-bottom: ${spacing(3)};
  }

  h3 {
    margin-bottom: ${spacing(2)};
  }

  p {
    margin: 0 0 ${spacing(4)};
  }

  p:last-child {
    margin-bottom: 0;
  }

  a {
    color: ${text_colorTextPrimary};
    text-decoration: underline;
  }

  ol,
  ul {
    margin: 0 0 ${spacing(2)} ${spacing(4)};
    padding: 0;
  }

  li {
    margin-bottom: ${spacing(2)};
  }
`

export const MessageWrapper = styled.div<{ sender: 'user' | 'ai' }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: ${(props) =>
    props.sender === 'user' ? 'flex-end' : 'flex-start'};
`

export const Timestamp = styled.span`
  margin-bottom: ${spacing(1)};
  color: ${text_colorTextSecondary};
  ${font_md};
`

export const MessageBox = styled.div<{ sender: 'user' | 'ai' }>`
  width: ${(props) => (props.sender === 'user' ? '85%' : '100%')};
  padding: ${(props) =>
    props.sender === 'user' ? spacing(3) : `${spacing(3)} 0`};
  background-color: ${(props) =>
    props.sender === 'user' ? base_colorSurfaceMuted : 'transparent'};
  border-radius: ${cornerRadius};
`

export const LoadingText = styled.div`
  display: flex;
  gap: ${spacing(4)};
  padding-top: ${spacing(4)};
  background: linear-gradient(
    90deg,
    ${text_colorTextPrimary} 0%,
    ${text_colorTextTertiary} 25%,
    ${text_colorTextPrimary} 50%,
    ${text_colorTextSecondary} 75%,
    ${text_colorTextPrimary} 100%
  );
  background-size: 200% auto;
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  animation: reporting-chat-gradient 4s linear infinite;

  @keyframes reporting-chat-gradient {
    0% {
      background-position: 200% center;
    }

    100% {
      background-position: 0% center;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`

export const ChatStatus = styled.div`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`

export const ChatError = styled.p`
  margin: 0 ${spacing(6)} ${spacing(3)};
  color: ${text_colorTextPrimary};
  ${font_md};
`

export const ChatToggle = styled.button`
  align-self: flex-start;
  margin: ${spacing(3)};
  padding: ${spacing(2)} ${spacing(3)};
  border: 1px solid ${base_colorContentBorder};
  border-radius: ${cornerRadius};
  background: transparent;
  color: ${text_colorTextPrimary};
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${text_colorTextPrimary};
    outline-offset: ${spacing(1)};
  }
`
